export const SET_CREATE_OR_EDIT_PRICE_GROUP = 'SET_CREATE_OR_EDIT_PRICE_GROUP';

export function setCreateOrEditPriceGroup(priceGroup) {
  return {
    type: SET_CREATE_OR_EDIT_PRICE_GROUP,
    priceGroup,
  };
}
